import React from "react";
import ReactDOM from "react-dom";
import * as serviceWorker from "./serviceWorker";
import axios from "axios";
import "./jquery-loader";
import App from "./App";
import "./index.css";
import "./static/css/theme.css";
import moment from "moment";
import { es_locale } from "./utils/Moment/es_local";
/* import "rsuite/dist/styles/rsuite-default.css"; */

const container = document.getElementById("root");
moment.locale("es", es_locale);

/* process.env.REACT_APP_ENVIRONMENT === "prod"
  ? (axios.defaults.baseURL = "http://52.207.167.191:8080/krezco/api/")
  : (axios.defaults.baseURL = "http://localhost:8080/krezco/api/"); */
axios.defaults.baseURL = "https://krezco.org/krezco/api/";

ReactDOM.render(<App />, container);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
// Attach root container
